import axios from 'axios';

import { State } from '../domain/state';

const loadStatesRefData = async (): Promise<State[]> => {
  const endpoint = '/qualification/ref_data/states';

  return await axios.get<State[]>(endpoint).then((res) => res.data);
};

export { loadStatesRefData };
